import { useState, useContext } from 'react'
import { AuthProvider } from './context/AuthContext'
import { LanguageProvider } from './context/LanguageContext'
import { AuthContext } from './context/AuthContext'
import LoginPage from './pages/LoginPage'
import Dashboard from './pages/Dashboard'
import SettingsPage from './pages/SettingsPage'
import './App.css'

function AppContent() {
  const { user, isLoading } = useContext(AuthContext)
  const [page, setPage] = useState('dashboard')

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#0a0a0a] via-[#1a1a1a] to-[#0a0a0a] flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-3 border-[#7a7a7a] border-t-[#a8a8a8] rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-[#a8a8a8]">Cargando...</p>
        </div>
      </div>
    )
  }

  if (!user) return <LoginPage />

  if (page === 'settings') {
    return <SettingsPage onBack={() => setPage('dashboard')} />
  }

  return <Dashboard onNavigate={setPage} />
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <AppContent />
      </LanguageProvider>
    </AuthProvider>
  )
}

export default App
